<template>
  <div>
    <DataSetExtensionFormModal
      v-if="isModalVisible"
      v-show="isModalVisible"
      :guest_period_data_set_id="this.guest_period_data_set_id"
      :guest_period_data_set_extension="this.guest_period_data_set_extension"
      :list_gpdse="this.guestPeriodDataSetsList"
      :list_trattements="this.trattement_days_array"
    />
    <div v-if="can_new" class="mypull-right span4 text-uppercase">
      <a class="js-popup" @click="showModal"
        ><span class="fa-light fa-plus pulsante_comando js-tooltip" title="" data-original-title="Nuovo"></span
      ></a>
    </div>
    <br />
    <table class="table fixed_header">
      <thead>
        <tr class="heading">
          <td></td>
          <th>{{ i18nJS.impegnativa }}</th>
          <th>#</th>
          <th>{{ i18nJS.service }}</th>
          <th>{{ i18nJS.data_inizio }}</th>
          <th>{{ i18nJS.date_asl_protocol }}</th>
          <th>{{ i18nJS.durata_impegnativa }}</th>
          <th>{{ i18nJS.data_fine }}</th>
          <th>{{ i18nJS.data_proroga }}</th>
          <th>{{ i18nJS.num_trattamenti }}</th>
          <th>{{ i18nJS.completed_gads }}</th>
          <th>{{ i18nJS.residue }}</th>
          <th>{{ i18nJS.status_gpde }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="gpdse in guestPeriodDataSetsList"
          :key="gpdse.id"
          :style="gpdse.status === 6 ? { 'background-color': '#FFAE9D' } : { 'background-color': 'white' }"
        >
          <td>
            <a v-if="gpdse.can_edit && gpdse.status == 1" class="js-popup" @click="editGpdse(gpdse)"
              ><span class="fa-light fa-pencil pulsante_comando"></span
            ></a>
            <a v-if="gpdse.can_destroy && gpdse.size === 0 && gpdse.status !== 2" class="js-popup" @click="deleteGpdse(gpdse)"
              ><span class="fa-light fa-trash pulsante_comando"></span
            ></a>
          </td>
          <td v-if="gpdse.status !== 2">{{ gpdse.protocol_name }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.progressive }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.service_description }}</td>
          <td v-if="gpdse.status !== 2">{{ formatDate(gpdse.datein) }}</td>
          <td v-if="gpdse.status !== 2">{{ formatDate(gpdse.date_asl_protocol) }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.duration }}</td>
          <td v-if="gpdse.status !== 2">{{ formatDate(gpdse.dateout) }}</td>
          <td v-if="gpdse.status !== 2">{{ formatDate(gpdse.dateprog) }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.nrgg_autorizzate }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.size }}</td>
          <td v-if="gpdse.status !== 2">{{ gpdse.residue }}</td>
          <td v-if="gpdse.status == 1">
            <div class="switch--container">
              <input type="checkbox" :checked="checkBox(gpdse)" @input="changeStatus(gpdse)" class="js-switch" />
            </div>
          </td>
          <td v-else-if="gpdse.status == 6">
            <div class="switch--container">
              <input type="checkbox" disabled :checked="checkBox(gpdse)" @input="changeStatus(gpdse)" class="js-switch" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import DataSetExtensionFormModal from '../guestPeriodDataSetExtensions/DataSetExtensionFormModal';

export default {
  name: 'guestPeriodDataSetExtensions',
  props: {
    guest_period_data_set_id: { type: Number, required: true },
    guest_status_id: { type: Number, required: true },
    can_new: { type: Boolean, required: true },
  },
  components: {
    DataSetExtensionFormModal,
  },
  data() {
    return {
      guestPeriodDataSetsList: [],
      isModalVisible: false,
      guest_period_data_set_extension: null,
      base_url: window.config.ePersonamService.ePersonamHost + '/' + window.locale,
      trattement_days_array: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  destroyed() {
    eventBus.$off('gpdseModalClosed', this.closeModalListener);
  },
  mounted() {
    eventBus.$on('gpdseModalClosed', this.closeModalListener);
    apiConnector()
      .get(this.base_url + '/guest_period_data_sets/' + this.guest_period_data_set_id + '/guest_period_data_sets_extensions.json')
      .then((res) => {
        if (res.data !== undefined) {
          this.guestPeriodDataSetsList = res.data;
        }
      })
      .catch((err) => {
        console.log('Errore nel caricamento della lista delle impegnative', err);
      });
  },
  methods: {
    closeModalListener() {
      this.isModalVisible = false;
    },
    checkBox(gpdse) {
      let isActive = false;
      if (gpdse.status === 6) isActive = true;
      return isActive;
    },
    showModal() {
      this.guest_period_data_set_extension = null;
      this.newGpdse = true;
      this.isModalVisible = true;
    },
    editGpdse(gpdse) {
      this.isModalVisible = true;
      this.guest_period_data_set_extension = gpdse;
      this.trattement_days_array = gpdse.extra_fields || {};
    },
    deleteGpdse(gpdse) {
      Loader.show();
      apiConnector()
        .delete(
          this.base_url +
            '/guest_period_data_sets/' +
            this.guest_period_data_set_id +
            '/guest_period_data_sets_extensions/' +
            gpdse.id +
            '.json',
        )
        .then((res) => {
          const index = this.guestPeriodDataSetsList.findIndex((gpdse) => gpdse.id === res.data.id);
          this.guestPeriodDataSetsList.splice(index, 1);
        })
        .catch((err) => {
          console.log('Errore nella eliminazione della impegnativa', err);
          Loader.hide();
        });
    },
    changeStatus(gpdse) {
      Loader.show();
      apiConnector()
        .post(
          this.base_url +
            '/guest_period_data_sets/' +
            this.guest_period_data_set_id +
            '/guest_period_data_sets_extensions/change_status.json',
          gpdse,
        )
        .then((res) => {
          const index = this.guestPeriodDataSetsList.findIndex((gpdse) => gpdse.id === res.data[0].id);
          this.guestPeriodDataSetsList.splice(index, 1);
          this.guestPeriodDataSetsList.splice(index, 0, res.data[0]);
          Loader.hide();
        })
        .catch((err) => {
          console.log('Errore nel cambiamento dello status', err);
          Loader.hide();
        });
    },
    formatDate(date) {
      if (date) return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>
